import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { HREF } from "../../db";

function Direction() {
  const { id } = useParams<{ id: string }>();
  if (id && (Number(id) < 1 || Number(id) > 4)) {
    return <></>;
  }
  const activeItem = id ? Number(id) : 1;

  return (
    <React.Fragment>
      <div className="local fl">
        <h3>Research</h3>
        <div className="dqwz fr">
          Current Position:&nbsp;
          <Link to={HREF.INDEX}>Hemo</Link>&gt;
          <Link to={HREF.RESEARCH}>Research</Link>&gt;
          <Link to={HREF.RESEARCH_DIRECTION}>Research Direction</Link>&gt;
          {
            [
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/1`}>
                Urban Computing
              </Link>,
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/2`}>
                Intelligent Transportation System
              </Link>,
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/3`}>
                Social Computing
              </Link>,
              <Link to={`${HREF.RESEARCH_DIRECTION_PART}/4`}>
               Affective Computing
            </Link>,
            ][activeItem - 1]
          }
        </div>
      </div>
      <div className="cy-title fl">
        <ul>
          <li>
            <Link to={HREF.RESEARCH_DIRECTION} className="ej-current">
              Research Direction
            </Link>
          </li>
          <li>
            <Link to={HREF.RESEARCH_PLATFORM}>Support Platform</Link>
          </li>
          <li>
            <Link to={HREF.RESEARCH_FOUNDATION}>Foundation</Link>
          </li>
        </ul>
      </div>
      <div className="content fl">
        <div className="Publications-title fl">
          <ul style={{ paddingLeft: "20px" }}>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/1`}
                title="Urban Computing"
                className={activeItem === 1 ? "Publications-current" : ""}
              >
                Urban Computing
              </Link>
            </li>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/2`}
                title="Intelligent Transportation System"
                className={activeItem === 2 ? "Publications-current" : ""}
              >
                Intelligent Transportation System
              </Link>
            </li>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/3`}
                title="Social Computing"
                className={activeItem === 3 ? "Publications-current" : ""}
              >
                Social Computing
              </Link>
            </li>
            <li>
              <Link
                to={`${HREF.RESEARCH_DIRECTION_PART}/4`}
                title="Social Computing"
                className={activeItem === 4 ? "Publications-current" : ""}
              >
                Affective Computing
              </Link>
            </li>
          </ul>
        </div>
        {[<Part1 />, <Part2 />, <Part3 />,<Part4 />][activeItem - 1]}
      </div>
    </React.Fragment>
  );
}

export { Direction };

function Part1() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          Since its establishment, this research group has undertaken a large
          number of scientific research tasks, accumulated more profound
          research work related to urban computing, computing social science,
          and intelligent transportation, and has rich project experience. Over
          the years, it has achieved a series of research results. A number of
          national-level projects, a series of academic papers and books have
          been published, and a number of patent authorizations and provincial
          and ministerial scientific research awards have been obtained, which
          has a certain influence at China and abroad.
        </p>
        <br />
        <h1 style={{ textAlign: "center" }}>
          <strong>Urban Computing</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          The core problems of urban computing mainly include four aspects:
          urban perception, Management of massive heterogeneous data,
          Collaborative computing of heterogeneous data, A hybrid system
          combining virtual and real, data travels back and forth in the
          physical and virtual world.
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          This research group has achieved outstanding results in the following
          aspects:
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          1) This research group proposes to systematically summarize the
          application of mobile crowdsourcing technology in smart cities based
          on the research on human behavior and spatiotemporal trajectory data
          mining and processing technology, and summarizes the MCS in smart
          cities from a new perspective Extensive and diversified applications,
          such as smart navigation, smart life, public services, and smart
          transportation (IEEE Internet of Things Journal 2019)；
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          2) This research group proposes to construct a traffic simulation
          scene of social vehicle travel based on floating car data and the
          division of urban functional areas. The effectiveness of this method
          is verified by realizing the scene of social vehicle travel in
          Beijing. This method has a strong Versatility, applicable to major
          cities in the world (IEEE Transactions on Vehicular Technology 2018)；
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          3) This research group proposes to analyze the floating car data to
          obtain the trajectory information of the taxi passengers, mine the
          different functional areas of the city spanned by these trajectories,
          and recommend the activity area and trajectory for the taxi driver,
          thereby reducing the flight rate and increasing the income (IEEE
          Transactions on Industrial Informatics 2017).
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          4) This research group proposes an unsupervised business district discovery framework by clustering on the embedding space of graph convolutional networks to solve the problem of business district discovery. 
          First, the proposed framework aggregates human movement features based on geographic similarity through graph convolutional networks. 
          Secondly, based on the embedding space of the graph convolutional network, hierarchical clustering is applied to mine the potential functional areas hidden in different human models. 
          Finally, through kernel density estimation, the semantic tags of the clustering results are obtained to discover potential business districts.
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          5) This research group proposes a taxi driving fraud detection framework based on a combination of time and space costs. 
          First, identify other vehicles and points of interest (POI) that are implicitly interacting and cooperating between the vehicle and the collaborative Internet of Vehicles (C-IoV), 
          and build a baseline trajectory model to determine the typical trajectory distribution. Second, use statistical models to calculate travel distribution, travel time, and travel cost to detect abnormal trajectories. 
          Finally, we can combine the perception of abnormal road environment to discover the root cause of abnormal trajectory.
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p5.png" />
        </p>
      </div>
    </div>
  );
}

function Part2() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <br />
        <h1 style={{ textAlign: "center" }}>
          <strong>Intelligent Transportation System</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong> 1) Intelligent traffic light control:</strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          According to the current situation and development trend of the
          traffic situation, the research group proposed a dynamic division
          method for traffic control sub-zones and an automatic identification
          algorithm for coordinated paths of sub-zones for congested areas and
          non-congested areas. A sub-zone signal control scheme generator for
          complex scenes is constructed, which realizes scheme generation based
          on multi-objective optimization and scheme generation based on expert
          experience. On this basis, an AI control method based on the training
          iteration of the program knowledge base is proposed, which realizes
          the automatic optimization and matching of signal control programs in
          various specific complex scenarios.
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong>
            2) Collaborative management of intelligent transportation:
          </strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          This research group uses the various traffic characteristic parameters
          after fusion processing to establish a multi-source urban traffic
          incident-driven traffic command and dispatch and signal coordination
          control model. In the framework of the command and dispatch model, AI
          video global perception and recognition technology, event prediction
          analysis technology, and real-time scheduling optimization technology
          are used for comprehensive command and coordinated management of urban
          events. In view of the urban special mission needs of special
          vehicles, research path planning guidance technology, trajectory
          tracking prediction technology, signal coordination optimization
          technology and global planning and dispatching technology to ensure
          the fast and smooth passage of emergency vehicles.
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/2020Emergency.png" />
        </p>
      </div>
    </div>
  );
}

function Part3() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <br />
        <h1 style={{ textAlign: "center" }}>
          <strong>Social Computing</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong>
            The transformation and quantification of social data, signals and
            intelligence into social intelligence is the core goal of social
            computing.
          </strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          1) This research group proposes a sustainable collaborator
          recommendation method based on meeting closures. Through the
          probability of new collaborators recognized by scholars participating
          in the meeting, this research group proposes a specific method to
          quantify academic meeting-academic cooperation, and introduces meeting
          closure relationships and cooperation Strength, build a weighted
          academic cooperation network, use the restart random walk algorithm to
          calculate the similarity between the target scholar and other
          scholars, and then recommend the target scholars as collaborators
          (IEEE Transactions on Computational Social Science 2019);
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          2) This research group proposes a paper recommendation method based on
          network representation learning that combines text and structure:
          firstly, the text information of the paper is represented by the text
          vector to generate the paper text vector to find papers with similar
          research content, and then the citation network is hidden Convert the
          structural features of the paper into vectors and find papers with
          similar network topologies, connect the text-similar papers and
          structurally similar papers with the target paper to reconstruct the
          citation network, and then learn the vector representation of the
          paper through network representation learning, and finally according
          to the paper vector Generate recommendation list based on similarity
          (IEEE Transactions on Emerging Topics in Computing 2018);
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          3) This research group proposes a dynamic evolution analysis method of
          academic cooperation based on academic age, which can more
          comprehensively reveal the academic cooperation mechanism and help
          policy makers formulate new policies to promote cooperation between
          scholars of different academic ages, especially It is to help young
          scholars integrate into the academic society faster (Scientometrics
          2017).
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          4) The research group proposed a novel University Analysis Framework (UPF), which contains a novel recurrent deep clustering model (Recurrent-DC) for learning deep representation and clustering; in this framework, 
          the clustering algorithm The continuous operation of is represented as steps in the loop process, stacked on top of the representation output by the stacked autoencoder (SAE). 
          This framework can be used to analyze university disciplines well. (Future Generation Computer Systems)
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          5) This research group proposes a mask recognition framework (ECMask) based on edge computing. 
          The framework consists of three main stages: video recovery, face detection, and mask recognition. 
          The framework can detect whether pedestrians are wearing masks. 
          Good help to prevent public epidemics, such as COVID-19. (IEEE Internet of Things Journal)
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          6) This research group proposes a public transportation analysis program based on heterogeneous mobile crowdsourcing. 
          The program designs a MCS-based public transportation data generation and collection method to overcome the problem of data scarcity. 
          At the same time, we propose a multi-constrained evolutionary algorithm to optimize users Travel itinerary. 
          This solution can well meet the travel needs of passengers (IEEE Transactions on Industrial Informatics)
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          7) The research group proposed a license plate recognition framework based on federated learning (FedLPR). 
          In addition, the research group also proposed a tilted license plate correction algorithm to improve the accuracy of license plate character recognition. 
          This framework can protect user privacy while protecting user privacy. 
          It has a high accuracy rate of license plate recognition, and its communication cost is acceptable. (IEEE Transactions on Industrial Informatics)
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          8) This research group proposes a vehicle co-location (CP) system based on federated learning (FedVCP), 
          which uses transfer learning to eliminate individual differences in vehicle positioning, and uses federated learning to solve the CP privacy problem. 
          The system can make full use of the potential of Social Internet of Things (IoT) and Collaborative Edge Computing (CEC) 
          to provide high-precision positioning correction while ensuring user privacy. (IEEE Transactions on Computational Social Systems)
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p17.png" />
        </p>
      </div>
    </div>
  );
}

function Part4() {
  return (
    <div className="content-con fl" id="vsb_content">
      <div className="WordSection1">
        <h1 style={{ textAlign: "center" }}>
          <strong>Affective computing</strong>
        </h1>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <br />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
          <strong>
          Emotional computing aims to make computers more intelligent by giving them the ability to recognize, understand and express human emotions.
          </strong>
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
        1) Fine-grained text sentiment analysis: This research group proposes a multi-scale fusion of text span characteristics of evaluation triples extraction method.
         Convolutional neural networks with different convolution kernel sizes are used to extract local features in different spans.
         And designed a simple span perception representation selection mechanism to better obtain span representation, 
         so as to better extract the evaluation triples (evaluation object, evaluation word, emotional polarity) in the review.
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p18.png" />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
        2) User portraits in the real estate field: In response to the problem of large investment but not obvious effects in the traditional propaganda methods of real estate companies,
         This research group proposes a real estate buyer profile modeling method based on information extraction and multi-attribute decision support.
         By extracting key phrases from unstructured text and matching artificially constructed templates,
         Realize the transformation from unstructured data to structured data in real scenarios.
         Using expert knowledge and an entropy-based weight distribution algorithm to calculate the relative importance of different attributes to different features,
         Construct characteristic representations of specific real estate buyers, so as to fully explore the implicit heterogeneous relationship between real estate buyers,
         Finally, the modeling of real estate buyer's portrait is realized, which can effectively help real estate companies to carry out precision marketing.
        </p>
        <p style={{ textAlign: "center" }}>
          <img src="/images/research/p19.png" />
        </p>
        <p style={{ textAlign: "justify", textIndent: "2em" }}>
        3) Text generation: Due to the scarcity of the corpus and the difficulty of manual labeling, text generation can solve this problem well.
        </p>
      </div>
    </div>
  );
}
